import React from 'react';

import { InputLabel, TextField } from '@material-ui/core';

import { Typography12 } from 'uiToolkit/Typography';

import { useObjectiveSidepanel } from '../context/ObjectiveSidePanelContext';

const ObjectiveDescription = () => {
  const { state, setDescription } = useObjectiveSidepanel();
  return (
    <div style={{ marginTop: '1.5rem' }}>
      <InputLabel htmlFor="description-field">
        <Typography12 bottomGutter={1}>Description</Typography12>
        <TextField
          id="description-field"
          variant="outlined"
          color="primary"
          multiline
          maxRows={3}
          rows={3}
          placeholder="Add details"
          autoFocus
          fullWidth
          value={state.description}
          onChange={(ev) => setDescription(ev.target.value)}
        />
      </InputLabel>
    </div>
  );
};

export default ObjectiveDescription;
